import { render, staticRenderFns } from "./DashboardEditorPanel.vue?vue&type=template&id=8d647a6c&scoped=true&"
import script from "./DashboardEditorPanel.vue?vue&type=script&lang=js&"
export * from "./DashboardEditorPanel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEditorPanel.vue?vue&type=style&index=0&id=8d647a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d647a6c",
  null
  
)

export default component.exports